import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetokonkandarshan() {



const cardData = {
keyword: "Pune to Konkan Darshan Innova Crysta Cab",
headingDescription: "Explore the scenic Konkan region from Pune with a comfortable Innova Crysta cab from Citysky Cabs. The service is suitable for families, friends and groups planning beach holidays, temple visits, sightseeing tours or weekend trips across the Konkan coast. With spacious seating, air-conditioned interiors, generous luggage capacity and private driver support, travellers can conveniently cover destinations such as Ratnagiri, Ganpatipule, Alibag, Tarkarli and other coastal attractions according to their planned itinerary.",
topPlaces: [
{
title: "Ratnagiri",
description: "Ratnagiri is one of the prominent destinations along the Konkan coast, known for its beaches, forts, coastal scenery and cultural attractions. A private Innova Crysta from Pune provides comfortable transportation for families and groups planning to explore Ratnagiri as part of a Konkan Darshan journey."
},
{
title: "Ganpatipule",
description: "Ganpatipule is a popular coastal pilgrimage and beach destination featuring the famous Ganpatipule Temple and scenic Arabian Sea coastline. Travelling in an Innova Crysta makes it convenient for families to combine temple darshan, beach visits and nearby sightseeing during their Konkan trip."
},
{
title: "Alibag",
description: "Alibag is a popular Konkan getaway known for beaches, coastal forts and relaxing surroundings. A spacious private cab from Pune allows families and groups to travel together comfortably while carrying luggage and planning additional stops around the Alibag region."
},
{
title: "Tarkarli",
description: "Tarkarli is known for its beautiful coastline, clear waters and water-based activities, making it an attractive destination for a longer Konkan holiday. An Innova Crysta is suitable for the extended road journey from Pune and provides useful space for passengers and holiday luggage."
},
{
title: "Malvan",
description: "Malvan combines coastal scenery, local cuisine, beaches and historical attractions, making it an important stop on a Konkan sightseeing itinerary. Private cab travel gives families and groups flexibility to explore Malvan and nearby destinations without depending on fixed shared transportation."
},
{
title: "Dapoli",
description: "Dapoli is a scenic coastal destination surrounded by beaches, temples and natural attractions. A Pune to Konkan Innova Crysta journey can include Dapoli as part of a family holiday or multi-day coastal tour, with comfortable seating for passengers and sufficient room for luggage."
},
{
title: "Harihareshwar",
description: "Harihareshwar is a popular spiritual and coastal destination known for its temple and scenic surroundings. Travellers from Pune can use a private Innova Crysta to combine temple visits with nearby beach sightseeing while keeping the entire group together during the journey."
},
{
title: "Murud-Janjira",
description: "Murud-Janjira is a well-known Konkan destination featuring the historic sea fort of Janjira and nearby beaches. A private cab makes it convenient for travellers to include Murud in a broader Konkan Darshan itinerary while enjoying comfortable road travel from Pune."
},
{
title: "Guhagar",
description: "Guhagar is a peaceful coastal destination known for its beach, temples and relaxed Konkan atmosphere. The spacious Innova Crysta is suitable for families and groups travelling from Pune who want to include Guhagar along with other coastal attractions during a multi-day trip."
},
{
title: "Shrivardhan",
description: "Shrivardhan is a scenic Konkan town surrounded by beaches, temples and coastal landscapes. A private Innova Crysta provides a convenient way to reach the destination from Pune and can support a broader itinerary covering nearby Harihareshwar and other coastal sightseeing points."
}
],
services: [
{
name: "Pune to Konkan Innova Crysta Cab",
description: "Pune to Konkan Innova Crysta Cab provides a spacious private vehicle for families and groups exploring the Konkan coast. The air-conditioned cabin, comfortable seating and luggage capacity make it suitable for beach holidays, temple visits, sightseeing tours and extended coastal journeys."
},
{
name: "Pune Konkan Darshan Innova Crysta Taxi",
description: "Pune Konkan Darshan Innova Crysta Taxi is suitable for travellers planning to visit multiple destinations along the Konkan coast. A private vehicle allows passengers to travel together while arranging temple visits, beaches, historical attractions and overnight stops according to their itinerary."
},
{
name: "Pune Konkan Darshan Cab Booking",
description: "Pune Konkan Darshan Cab Booking offers a convenient way to reserve private transportation for a planned Konkan sightseeing journey. The Innova Crysta provides spacious seating and useful luggage space for families and groups travelling across several coastal destinations."
},
{
name: "Pune Konkan Innova Crysta Rental",
description: "Pune Konkan Innova Crysta Rental provides a practical travel option for passengers planning short or extended Konkan trips. The spacious vehicle can support family holidays, beach tours, temple circuits and multi-day sightseeing journeys from Pune."
},
{
name: "Pune to Konkan Innova Crysta on Rent",
description: "Pune to Konkan Innova Crysta on Rent offers private transportation for travellers heading from Pune toward the Konkan region. Comfortable seating, air conditioning and luggage capacity make the vehicle suitable for long road journeys and family holiday plans."
},
{
name: "Pune to Konkan Innova Crysta Hire",
description: "Pune to Konkan Innova Crysta Hire is a convenient option for families and groups looking for a dedicated vehicle for coastal travel. The cab can be used for one-way journeys, return trips and customized Konkan itineraries covering multiple destinations."
},
{
name: "Pune Konkan AC Innova Crysta Cab",
description: "Pune Konkan AC Innova Crysta Cab provides an air-conditioned cabin for comfortable travel across the long routes connecting Pune with the Konkan coast. The vehicle is suitable for families, senior passengers and groups carrying luggage during multi-day coastal tours."
},
{
name: "Pune Konkan Luxury Innova Crysta Cab",
description: "Pune Konkan Luxury Innova Crysta Cab offers a comfortable private travel arrangement for travellers seeking a spacious vehicle for their Konkan holiday. Premium-feel interiors, air conditioning and generous seating make it suitable for family and group journeys."
},
{
name: "Pune Konkan 7 Seater Innova Crysta",
description: "Pune Konkan 7 Seater Innova Crysta is suitable for families and small groups who want to travel together along the Konkan coast. The spacious cabin provides comfortable passenger seating along with practical room for luggage and holiday belongings."
},
{
name: "Pune Konkan One Way Innova Crysta Cab",
description: "Pune Konkan One Way Innova Crysta Cab is useful for travellers who need private transportation from Pune to a selected Konkan destination. The service provides dedicated road travel for passengers who do not require a standard return journey in the same arrangement."
},
{
name: "Pune Konkan Round Trip Innova Crysta Cab",
description: "Pune Konkan Round Trip Innova Crysta Cab provides convenient transportation for travellers planning to explore the Konkan region and return to Pune. The private vehicle allows the group to coordinate sightseeing, beach visits and return travel around their planned schedule."
},
{
name: "Pune Konkan Outstation Innova Crysta",
description: "Pune Konkan Outstation Innova Crysta offers a spacious vehicle for long-distance travel from Pune to destinations across the Konkan region. It is suitable for multi-day trips where passengers need comfortable seating, air conditioning and adequate luggage space."
},
{
name: "Pune Konkan Family Trip Cab",
description: "Pune Konkan Family Trip Cab provides private transportation for families planning a coastal holiday or pilgrimage journey. The Innova Crysta offers comfortable seating and useful luggage capacity, making it convenient for parents, children and senior family members travelling together."
},
{
name: "Pune Konkan Group Travel Cab",
description: "Pune Konkan Group Travel Cab is suitable for friends, relatives and small groups exploring the Konkan coast together. A spacious Innova Crysta keeps the group in one vehicle while allowing passengers to organize multiple sightseeing and overnight stops during the trip."
},
{
name: "Affordable Pune Konkan Innova Crysta Cab",
description: "Affordable Pune Konkan Innova Crysta Cab provides a practical private transportation option for travellers planning a Konkan holiday. The service combines comfortable seating, useful luggage capacity and dedicated travel support for families and groups visiting coastal destinations."
},
{
name: "Pune Konkan Beach Tour Cab",
description: "Pune Konkan Beach Tour Cab is designed for travellers who want to explore beaches along the Konkan coastline. The private Innova Crysta allows families and groups to carry their belongings comfortably and plan visits to multiple beaches according to their available time."
},
{
name: "Pune Konkan Sightseeing Innova Crysta",
description: "Pune Konkan Sightseeing Innova Crysta is suitable for multi-stop coastal tours covering beaches, temples, forts and scenic destinations. Its spacious cabin and private travel format make it convenient for travellers who want flexibility throughout their sightseeing itinerary."
},
{
name: "Pune Konkan Tourist Cab",
description: "Pune Konkan Tourist Cab provides private transportation for visitors exploring popular Konkan destinations from Pune. The Innova Crysta is suitable for families and groups who want comfortable road travel while including several tourist attractions in one itinerary."
},
{
name: "Pune Konkan Darshan Taxi Service",
description: "Pune Konkan Darshan Taxi Service offers dedicated transportation for travellers planning a religious and sightseeing journey across the Konkan region. The private cab can accommodate families and groups while providing convenient travel between temples, beaches and cultural attractions."
},
{
name: "Pune Konkan Innova Crysta Cab Near Me",
description: "Pune Konkan Innova Crysta Cab Near Me is useful for travellers searching for convenient private transportation for a Konkan journey from Pune. An Innova Crysta provides comfortable seating and sufficient luggage space for families and groups starting their coastal trip."
},
{
name: "Pune Konkan Private Cab",
description: "Pune Konkan Private Cab gives travellers a dedicated vehicle for their coastal journey without sharing the ride with unrelated passengers. Families and groups can organize pickup, sightseeing stops, overnight destinations and return travel according to their own plans."
},
{
name: "Pune Konkan Innova Crysta Cab Hire",
description: "Pune Konkan Innova Crysta Cab Hire provides a spacious vehicle for travellers planning a beach holiday, pilgrimage or sightseeing tour along the Konkan coast. The private cab is suitable for both shorter getaways and longer multi-destination journeys."
},
{
name: "Pune Konkan Rental Car with Driver",
description: "Pune Konkan Rental Car with Driver offers convenient driving support for passengers travelling across the Konkan region. The Innova Crysta provides comfortable seating and luggage capacity while the dedicated driver handles the road journey between planned destinations."
},
{
name: "Pune Konkan Weekend Trip Cab",
description: "Pune Konkan Weekend Trip Cab is suitable for travellers planning a short coastal escape from Pune. A private Innova Crysta allows families and groups to combine beaches, temples and scenic locations while keeping the weekend itinerary flexible and comfortable."
},
{
name: "Pune Konkan Family Tour Innova Crysta",
description: "Pune Konkan Family Tour Innova Crysta provides spacious private transportation for families exploring the Konkan coast. The vehicle is useful for carrying luggage during multi-day holidays and visiting several beaches, temples and tourist attractions without changing vehicles."
}
],
tableData: [
["Pune to Konkan Innova Crysta Cab"],
["Pune Konkan Darshan Innova Crysta Taxi"],
["Pune Konkan Darshan Cab Booking"],
["Pune Konkan Innova Crysta Rental"],
["Pune to Konkan Innova Crysta on Rent"],
["Pune to Konkan Innova Crysta Hire"],
["Pune Konkan AC Innova Crysta Cab"],
["Pune Konkan Luxury Innova Crysta Cab"],
["Pune Konkan 7 Seater Innova Crysta"],
["Pune Konkan One Way Innova Crysta Cab"],
["Pune Konkan Round Trip Innova Crysta Cab"],
["Pune Konkan Outstation Innova Crysta"],
["Pune Konkan Family Trip Cab"],
["Pune Konkan Group Travel Cab"],
["Affordable Pune Konkan Innova Crysta Cab"],
["Pune Konkan Beach Tour Cab"],
["Pune Konkan Sightseeing Innova Crysta"],
["Pune Konkan Tourist Cab"],
["Pune Konkan Darshan Taxi Service"],
["Pune Konkan Innova Crysta Cab Near Me"],
["Pune Konkan Private Cab"],
["Pune Konkan Innova Crysta Cab Hire"],
["Pune Konkan Rental Car with Driver"],
["Pune Konkan Weekend Trip Cab"],
["Pune Konkan Family Tour Innova Crysta"]
],
whychoose: [
{
WhyChooseheading: "Spacious Comfort for Konkan Journeys",
WhyChoosedescription: "The Innova Crysta offers generous cabin space for families and groups travelling from Pune toward the Konkan coast. Comfortable seating and useful luggage capacity make it practical for long drives, beach holidays and multi-day sightseeing trips."
},
{
WhyChooseheading: "Ideal for Multi-Destination Tours",
WhyChoosedescription: "Konkan Darshan can involve several beaches, temples, forts and coastal towns. A private cab provides the flexibility to include multiple destinations in one itinerary without depending on separate public transportation arrangements."
},
{
WhyChooseheading: "Comfortable AC Travel",
WhyChoosedescription: "Air-conditioned interiors provide a pleasant environment during extended road journeys between Pune and coastal destinations. This makes the Innova Crysta suitable for families, senior passengers and groups spending considerable time travelling between sightseeing locations."
},
{
WhyChooseheading: "Convenient Family Travel",
WhyChoosedescription: "Families can travel together in one spacious private vehicle and keep their luggage organized throughout the journey. The arrangement is useful for beach holidays, temple visits and longer Konkan tours involving children and senior family members."
},
{
WhyChooseheading: "Flexible Beach and Sightseeing Plans",
WhyChoosedescription: "A private vehicle allows travellers to organize their Konkan itinerary around preferred beaches, temples, forts and scenic attractions. Additional stops can be included when time permits, making the journey adaptable to the group's sightseeing plans."
},
{
WhyChooseheading: "Suitable for Weekend Getaways",
WhyChoosedescription: "The Innova Crysta is a practical choice for groups planning a weekend escape from Pune to destinations such as Alibag, Dapoli, Harihareshwar or other Konkan locations. Private transportation helps make the short itinerary easier to coordinate."
},
{
WhyChooseheading: "Dedicated Driver Support",
WhyChoosedescription: "A dedicated driver handles the road journey while passengers can focus on enjoying the coastal trip. This is particularly useful when the itinerary includes multiple destinations, unfamiliar roads and several sightseeing stops."
},
{
WhyChooseheading: "Useful Luggage Space",
WhyChoosedescription: "Konkan holidays often involve beachwear, bags and personal travel belongings, especially during multi-day trips. The Innova Crysta provides practical space for passengers and luggage, supporting a more convenient journey from Pune through the coastal itinerary."
}
]
};













const faqData = [
{
question: "Can I book an Innova Crysta from Pune for Konkan Darshan?",
answer: "Travellers planning a Konkan Darshan from Pune can enquire about an Innova Crysta for the journey. Citysky Cabs can coordinate the cab according to your travel dates, Pune pickup location, passenger count, selected destinations, luggage requirements, and planned return schedule."
},
{
question: "Is Innova Crysta suitable for a Konkan Darshan trip from Pune?",
answer: "An Innova Crysta can work well for families and small groups exploring Konkan together. A private vehicle keeps everyone on the same itinerary while providing a practical arrangement for carrying luggage during a trip that may include beaches, temples, forts, coastal towns, and multiple overnight stops."
},
{
question: "Which places can I cover during a Konkan Darshan from Pune by Innova Crysta?",
answer: "The Konkan itinerary can be customized around destinations such as Ganpatipule, Ratnagiri, Tarkarli, Malvan, Sindhudurg, Harihareshwar, Dapoli, and other coastal locations. The final route can be planned based on the number of days available and the places your group wants to include."
},
{
question: "Can I hire an Innova Crysta for a multi-day Konkan trip?",
answer: "Travellers planning an extended coastal tour can enquire about a multi-day Innova Crysta booking from Pune. Sharing your preferred destinations, travel dates, overnight plans, passenger count, and expected return date helps Citysky Cabs understand the complete itinerary before arranging the transportation."
},
{
question: "Can families book an Innova Crysta for Konkan Darshan?",
answer: "Families can choose a private Innova Crysta when they want to explore Konkan together without coordinating multiple vehicles. The arrangement can be useful for groups travelling with children, parents, senior citizens, or several bags during a longer coastal holiday."
},
{
question: "Can I plan a Konkan temple and sightseeing tour in an Innova Crysta?",
answer: "An Innova Crysta can be considered for a Konkan itinerary combining religious places with sightseeing destinations. Depending on your schedule, the route can include temples, beaches, forts, coastal viewpoints, and local attractions while keeping the group together throughout the journey."
},
{
question: "Can I book a round-trip Innova Crysta from Pune for Konkan Darshan?",
answer: "A round-trip cab can be arranged for travellers who want to begin their Konkan tour in Pune and return after completing the planned destinations. During the enquiry, mention the expected trip duration, locations to be visited, passenger count, and preferred return timing."
},
{
question: "Can I travel to Konkan with luggage in an Innova Crysta?",
answer: "Passengers can provide their approximate luggage details when enquiring about the cab. This is particularly useful for multi-day Konkan trips where families and groups may carry clothing, personal belongings, beach essentials, and other travel items."
},
{
question: "Can I customize my Pune to Konkan Darshan route with Citysky Cabs?",
answer: "The Konkan route can be discussed according to the places your group wants to cover and the amount of time available. Provide the pickup point in Pune, travel dates, destinations, passenger count, overnight requirements, and return plan so Citysky Cabs can coordinate the Innova Crysta around your itinerary."
},
{
question: "How can I book a Pune to Konkan Darshan Innova Crysta Cab?",
answer: "To enquire about an Innova Crysta for Konkan Darshan, share your Pune pickup location, travel date, number of passengers, luggage requirements, preferred coastal destinations, number of travel days, and one-way or return preference. Citysky Cabs can then coordinate the cab arrangement based on your planned Konkan tour."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Amol Sawant",
feedback:
"We planned a Konkan trip from Pune covering Ganpatipule, Ratnagiri and a few coastal spots with our relatives. An Innova Crysta suited our group because everyone could travel together with the luggage. Citysky Cabs discussed our multi-day route before the trip, which helped us organize the journey around our sightseeing plans.",
rating: 5
},
{
id: 2,
name: "Miss. Manasi Kulkarni",
feedback:
"Our family wanted to explore Konkan at a relaxed pace rather than follow a fixed group tour. We hired an Innova Crysta and planned our coastal stops in advance. The vehicle arrangement through Citysky Cabs made it convenient to move between the different places, especially with children and several bags travelling with us.",
rating: 5
}
];














































    const Images = [

    { place: "/images/keyword/1.jpg", text: "Innova Crysta Cab in Pune", link: "innova-crysta-cab-in-pune" },

    { place: "/images/keyword/2.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },

    { place: "/images/keyword/3.jpg", text: "Innova Crysta Cabs / Taxi Booking in Pune", link: "innova-crysta-cabs-taxi-booking-in-pune" },

    { place: "/images/keyword/4.jpg", text: "Pune to Mahabaleshwar Innova Crysta Cab", link: "pune-to-mahabaleshwar-innova-crysta-cab" },

    { place: "/images/keyword/5.jpg", text: "Book Innova Crysta for Outstation From Pune", link: "book-innova-crysta-for-outstation-from-pune" },

    { place: "/images/keyword/6.jpg", text: "Innova Crysta Cabs for Pune Airport", link: "innova-crysta-cabs-for-pune-airport" },

    { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Airport Innova Crysta", link: "pune-to-mumbai-airport-innova-crysta" },

    { place: "/images/keyword/8.jpg", text: "Innova Crysta Cab for Corporate Office", link: "innova-crysta-cab-for-corporate-office" },

    { place: "/images/keyword/9.jpg", text: "Mumbai Airport to Pune Innova Crysta Cabs", link: "mumbai-airport-to-pune-innova-crysta-cabs" },

    { place: "/images/keyword/10.jpg", text: "Pune to Shirdi Innova Crysta", link: "pune-to-shirdi-innova-crysta" },

    { place: "/images/keyword/11.jpg", text: "Pune Aurangabad Innova Crysta Cab Service", link: "pune-aurangabad-innova-crysta-cab-service" },

    { place: "/images/keyword/12.jpg", text: "Pune to Goa Innova Crysta Cab", link: "pune-to-goa-innova-crysta-cab" },

    { place: "/images/keyword/13.jpg", text: "Pune to Bangalore Innova Crysta Cab", link: "pune-to-bangalore-innova-crysta-cab" },

    { place: "/images/keyword/14.jpg", text: "Pune to Hyderabad Innova Crysta Rental Cab", link: "pune-to-hyderabad-innova-crysta-rental-cab" },

    { place: "/images/keyword/15.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-2" },

    { place: "/images/keyword/16.jpg", text: "Pune to Lavasa Innova Crysta Cab Booking", link: "pune-to-lavasa-innova-crysta-cab-booking" },

    { place: "/images/keyword/17.jpg", text: "Pune Darshan Innova Crysta Cabs", link: "pune-darshan-innova-crysta-cabs" },

    { place: "/images/keyword/18.jpg", text: "Innova Crysta Cabs in Pune", link: "innova-crysta-cabs-in-pune" },

    { place: "/images/keyword/19.jpg", text: "Innova Car Rental In Pune", link: "innova-car-rental-in-pune" },

    { place: "/images/keyword/20.jpg", text: "Innova Taxi Service in Pune", link: "innova-taxi-service-in-pune" },

    { place: "/images/keyword/21.jpg", text: "Book Innova for Outstation Pune", link: "book-innova-for-outstation-pune" },

    { place: "/images/keyword/22.jpg", text: "Innova Crysta On Rent In Pune", link: "innova-crysta-on-rent-in-pune-3" },

    { place: "/images/keyword/23.jpg", text: "Pune to Mahabaleshwar Panchgani Innova Crysta Cabs", link: "pune-to-mahabaleshwar-panchgani-innova-crysta-cabs" },

    { place: "/images/keyword/24.jpg", text: "Pune to Outstation Innova Crysta Booking", link: "pune-to-outstation-innova-crysta-booking" },

    { place: "/images/keyword/25.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-4" },


];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Konkan Darshan Innova Crysta Cab",
  "image": "https://www.cityskycab.in/assets/images/pune-to-konkan-darshan-innova-crysta-cab.webp",
  "description": "Pune to Konkan Darshan Innova Crysta Cab from Citysky Cabs is a comfortable private travel option for families, friends and groups planning a coastal Konkan tour from Pune. The service includes Pune to Konkan Innova Crysta Cab, Konkan Darshan Innova Crysta Taxi, cab booking, rental, on-rent and hire options, along with AC and luxury travel choices. A spacious 7-seater Innova Crysta provides comfortable seating and practical luggage space for longer road journeys, making it suitable for multi-day Konkan trips, beach visits, family holidays, temple tours and sightseeing across multiple destinations. Passengers can plan one-way or round-trip travel according to their itinerary, with a dedicated vehicle that offers flexibility for different stops and travel schedules.",
  "brand": {
    "@type": "Brand",
    "name": "Citysky Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.cityskycab.in/pune-to-konkan-darshan-innova-crysta-cab"
  }
};


    return (
        <div>



<Helmet>
  <title>
    Pune to Konkan Darshan Innova Crysta Cab | Pune Konkan 7 Seater Crysta for Coastal Tours | +91 8554819191
  </title>

  <meta
    name="description"
    content="Explore Konkan from Pune in a spacious 7-seater AC Innova Crysta with Citysky Cabs. Ideal for family holidays, beach trips, temple tours, multi-day sightseeing and flexible round trips."
  />

  <meta
    name="keywords"
    content="Pune to Konkan Innova Crysta Cab, Pune Konkan Darshan Innova Crysta Taxi, Pune Konkan Darshan Cab Booking, Pune Konkan Innova Crysta Rental, Pune to Konkan Innova Crysta on Rent, Pune to Konkan Innova Crysta Hire, Pune Konkan AC Innova Crysta Cab, Pune Konkan Luxury Innova Crysta Cab, Pune Konkan 7 Seater Innova Crysta, Pune Konkan One Way Innova Crysta Cab, Pune Konkan Round Trip Innova Crysta Cab, Pune to Konkan Darshan Innova Crysta Cab, Pune Konkan Tour Cab, Pune Konkan Family Taxi, Pune Konkan Beach Trip Cab, Pune Konkan Sightseeing Taxi, Pune Konkan Temple Tour Cab, Pune Konkan Multi Day Cab, Pune Konkan Outstation Innova Crysta, Pune Konkan Private Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="sisf-banner sis-br-radius mt-3 position-relative">
                <div className="banner-img">
                    <figure>
                      {/* <img
                            src="/images/page-banner.jpg"
                            alt="Mauliwala Travels Urbania and Mini Bus Rental Pune"
                        /> */}
                    </figure>
                </div>

                <div className="sisf-page-title sisf-m sisf-title--standard sisf-alignment--center">
                    <div className="sisf-m-inner container">
                        <div className="sisf-m-content sisf-content-grid">
                            <h1 className="sisf-m-title text-white sis-text-anime-style-3 entry-title">
                                {cardData.keyword}
                            </h1>
                        </div>
                    </div>
                </div>
            </div>














            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/55.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Citysky Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Citysky Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Citysky Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918554819191" className="pc-call">+91 8554819191 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+918459883515" className="pc-call">+91 8459883515 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918459883515
"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918459883515" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@cityskycab.in" className="pc-email">
                                            booking@cityskycab.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Citysky Cabs</strong><br />

                                            Office No,307,3rd Floor,
                                            52, Sinhgad Rd, Wadgaon Budruk,
                                            Narhe, Pune, Maharashtra,India- 411041.






                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetokonkandarshan;